module.exports = __webpack_public_path__ + "img/2e3b406.png";